import React from "react";
import LearningHubImage from "../../assets/images/learning-hub.png";


const LearningSection = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-0 md:py-0 bg-white">
      <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 lg:gap-16">
        {/* Left side - Image */}
        <div className="w-full md:w-1/2">
          <div className="relative">
            <img
              src={LearningHubImage}
              alt="People learning with digital interface"
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>

        {/* Right side - Content */}
        <div className="w-full md:w-1/2 space-y-6">
          <div className="text-6xl md:text-7xl lg:text-8xl font-bold">
            <span className="bg-gradient-to-r from-amber-500 via-lime-500 to-teal-500 bg-clip-text text-transparent">
              80%
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            Industry-leading completion rate
          </h2>

          <p className="text-base md:text-lg text-gray-700">
            Give your workforce access to always-available live classes,
            enabling continuous live learning at their convenience—
            <span className="font-semibold">
              all led by experts, encouraging high engagement.
            </span>
          </p>

          <div className="pt-4">
            <button className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-8 rounded-lg transition-colors duration-300">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningSection;
